export default {
  path: "/department",
  props: true,
  component: () => import("@/views/LayoutView.vue"),
  children: [
    {
      path: "",
      redirect: "place/list",
    },
    {
      path: ":dir(place)/view/:id",
      name: "departmentPlaceView",
      component: () => import("@/views/department/place/PlaceView.vue"),
    },
    {
      path: ":dir(place)/:subdir(draft)/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: {
        getDataUrl: "place?status_id=1",
      },
    },
    {
      path: ":dir(place)/:subdir(published)/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: {
        getDataUrl: "place?status_id=2",
      },
    },
    {
      path: ":dir(place)/:subdir(archive)/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: {
        getDataUrl: "place?status_id=3",
      },
    },
    {
      path: ":dir(place)/:subdir(revoked)/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: {
        getDataUrl: "place?status_id=4",
      },
    },
    {
      path: ":parentDir(place)/:placeId/:dir(apply)/view/:id",
      name: "placeView",
      component: () => import("@/views/department/place/apply/ApplyView.vue"),
    },

    // Kоммисия
    {
      path: ":dir(commision)/view/:id",
      component: () => import("@/components/default/view/DefaultView.vue"),
      props: true,
    },

    // Акт
    {
      path: ":dir(act)/view/:id",
      name: "departmentCoursePlaceView",
      component: () => import(`@/views/department/act/ActView.vue`),
    },

    //Organizations
    {
      path: ":dir(organization)/:subdir(new)/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: {
        getDataUrl: "organization?status_id=2",
      },
    },
    {
      path: ":dir(organization)/:subdir(allowed)/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: {
        getDataUrl: "organization?status_id=3",
      },
    },
    {
      path: ":dir(organization)/:subdir(not-allowed)/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: {
        getDataUrl: "organization?status_id=4",
      },
    },
    {
      path: ":dir(organization)/:subdir(out-of-date)/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: {
        getDataUrl: "organization?status_id=5",
      },
    },
    {
      path: ":dir(organization)/:subdir(blocked)/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: {
        getDataUrl: "organization?status_id=6",
      },
    },
    {
      path: ":dir(organization)/view/:id",
      component: () => import("@/components/default/view/DefaultView.vue"),
      props: true,
    },

    //Monitoring
    {
      path: ":dir(main)",
      component: () => import("@/views/department/monitoring/MainMonitoring.vue"),
    },
    {
      path: ":dir(branches)",
      component: () => import("@/views/head-department/monitoring/BranchesMonitoring.vue"),
    },

    {
      path: ":dir(branches)/:id",
      name: "BranchDetails",
      component: () => import("@/views/head-department/monitoring/BranchDetails.vue"),
      props: true
    },

    {
      path: ":dir(act-services)/view/:id",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: route => ({
        getDataUrl: `/act-services/${route.params.id}`,
        subject: 'act'
      }),
    },

    {
      path: ":dir(act-services)/:id/act/:act_id",
      component: () => import("@/views/organization/actService/ActServiceView.vue"),
      props: route => ({
        getDataUrl: `/act-services/${route.params.id}/act/${route.params.act_id}`,
        subject: 'act'
      }),
    },

    {
      path: ":dir(supplier-management)/view/:id",
      component: () => import("@/views/department/supplierManagement/supplierManagementView.vue"),
      props: true,
    },
    
    {
      path: ":dir/(list)*",
      component: () => import("@/components/default/list/DefaultList.vue"),
      props: true,
    },
    {
      path: ":dir(tickets)/view/:id",
      component: () => import("@/views/superadmin/ticket/TicketView.vue"),
    },
  ],
};
